var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EBEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 15.351 22.544 9h-1.235l-4.526 5.515L13.17 9H9l5.466 8.34L9 24h1.235l4.78-5.824L18.83 24H23l-5.668-8.649Zm-1.692 2.062-.554-.83-4.406-6.608h1.897l3.556 5.332.554.83 4.622 6.933h-1.897l-3.772-5.657Z",
    fill: "#414E5F"
  })));
};
export default SvgTwitter;